/* =========================================================================
   Óptica Córdoba — Página «Córdoba» (Sobre nosotros)
   · Revelado al hacer scroll (mejora progresiva, sin IntersectionObserver
     porque no dispara en la vista previa del panel Browser).
   · Carrusel social: flechas prev/next, arrastre con ratón, límites.
   ========================================================================= */
(function () {
  'use strict';

  // Señal para el failsafe en línea del <head>: si esto corre, no hace falta.
  window.__storyReady = true;

  var doc = document;
  function each(list, fn) { Array.prototype.forEach.call(list || [], fn); }

  /* ---- Revelado al hacer scroll ---------------------------------------- */
  function reveal() {
    var vh = window.innerHeight || doc.documentElement.clientHeight;
    each(doc.querySelectorAll('.st-reveal:not(.is-visible)'), function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.92 && r.bottom > 0) el.classList.add('is-visible');
    });
    return doc.querySelectorAll('.st-reveal:not(.is-visible)').length;
  }

  function onScroll() {
    if (reveal() === 0) {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    }
  }

  function initReveal() {
    reveal();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    window.addEventListener('load', reveal);
    setTimeout(reveal, 300);
    setTimeout(reveal, 700);
  }

  /* ---- Carrusel social -------------------------------------------------- */
  function initCarousel(track) {
    if (track.__stInit) return;
    track.__stInit = true;

    var section = track.closest('.st-social');
    var prev = section && section.querySelector('[data-st-prev]');
    var next = section && section.querySelector('[data-st-next]');

    function pageStep() {
      var item = track.querySelector('.st-social__item');
      if (!item) return track.clientWidth;
      var cs = getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap) || 0;
      var itemW = item.getBoundingClientRect().width + gap;
      var perView = Math.max(1, Math.round(track.clientWidth / itemW));
      return itemW * perView;
    }

    function update() {
      var max = track.scrollWidth - track.clientWidth - 1;
      var atStart = track.scrollLeft <= 1;
      var atEnd = track.scrollLeft >= max;
      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd;
      // si no hay desbordamiento, oculta la navegación
      if (section) section.classList.toggle('st-social--static', max <= 1);
    }

    if (prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: -pageStep(), behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: pageStep(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();

    /* arrastre con el ratón (el táctil usa el scroll nativo) */
    var down = false, startX = 0, startLeft = 0, moved = false;

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      down = true; moved = false;
      startX = e.clientX; startLeft = track.scrollLeft;
      track.classList.add('is-dragging');
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      track.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      track.classList.remove('is-dragging');
      update();
    });
    // no navegar si el usuario estaba arrastrando
    track.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
  }

  /* ---- Arranque --------------------------------------------------------- */
  function boot() {
    initReveal();
    each(doc.querySelectorAll('.st-social__track[data-st-track]'), initCarousel);
  }

  if (doc.readyState !== 'loading') boot();
  else doc.addEventListener('DOMContentLoaded', boot);

  // Editor de temas: al recargar/insertar una sección
  doc.addEventListener('shopify:section:load', function (e) {
    var scope = (e.target && e.target.querySelectorAll) ? e.target : doc;
    each(scope.querySelectorAll('.st-social__track[data-st-track]'), initCarousel);
    reveal();
  });
})();
